<script>
import { extend } from 'sk-ui/lib/utils/util.js'
import { getAvailableHeight } from 'sky-engine/utils/dom'
import formController from 'sky-engine/views/formController'
import { createViewVNode } from 'sky-engine/views/ViewManager'

import { createProject, editProject } from '@/api/project'
import { getIndustryList } from '@/api/setting'
import ptFormView from '@/store/modules/pocMng/metaData/ptFormForScene'

export default {
  name: 'SkyStepViewCreateProject',
  components: {
    formController
  },
  props: {
    projectId: {
      type: String
    },
    projectState: {
      type: String,
      default: null
    }
  },
  methods: {
    updateAvailableHeight() {
      this.$refs.SkyStepViewCreateProject.availableHeight = getAvailableHeight(this.$el) + this._rem2px(55)
    },
    getData() {
      return {
        dataChange: false,
        busDATA: {}
      }
    },
    updateData() {
      getIndustryList().then(res => {
        //增加过滤普教
        var list = res.data.content.itemArr.filter(item => {
          return item.industryCode !== 'PJ' && item.industryCode !== 'GJ'
        })
        var changeList = []
        for (const iterator of list) {
          changeList.push({
            id: iterator.id,
            value: iterator.id,
            label: iterator.industryName
          })
        }
        this.$refs.SkyStepViewCreateProject.view.content[0].$options = changeList
        if (this.projectId != null) {
          this.$refs.SkyStepViewCreateProject.view.content[0].$el = {
            class: 'wsp-custom-edit-industry-disabled',
            disabled: true
          }
        }
      })
    },
    async saveStep() {
      let result = false

      await this.$refs.SkyStepViewCreateProject.formRef.validate(valid => {
        result = valid
      })
      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '表单存在必填项未填写，请确认', type: 'error' })
        return false
      }
      var from_data = this.$refs.SkyStepViewCreateProject.$refs.renderForm.value

      var reportSize = 0
      var list = []
      let bindReportTooMore = false
      if (from_data.envRelateSceneArr) {
        from_data.envRelateSceneList = from_data.envRelateSceneArr.map(item => {
          reportSize += item.envData.length
          if (reportSize > 5) {
            bindReportTooMore = true
          }
          item.envData.map(obj => list.push(obj.id))
          return {
            collectReportIdArr: item.envData.map(obj => obj.id),
            sceneId: item.scene
          }
        })
      }
      if (bindReportTooMore) {
        this.$store.dispatch('OpenNotification', { message: '一个场景最多只支持绑定5个报告', type: 'error' })
        return false
      }
      if (!result) {
        return false
      }
      from_data.salesId = from_data.salesIdLabel.id
      from_data.presalesId = from_data.presalesIdLabel.id
      from_data.postsalesIdList = []
      from_data.postsalesIdLabelList.forEach(element => {
        from_data.postsalesIdList.push(element.id)
      })
      from_data.extensionIdList = []
      from_data.extensionIdLabelList.forEach(element => {
        from_data.extensionIdList.push(element.id)
      })

      if (this.projectId) {
        from_data.id = this.projectId
        await editProject(from_data).then(res => {
          this.$emit('changeProjectId', {
            projectId: this.projectId,
            customer: from_data.customer,
            industryId: from_data.industryId
          })
          result = false
        })
      }

      return result
    },
    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      let result = false

      await this.$refs.SkyStepViewCreateProject.formRef.validate(valid => {
        result = valid
      })

      var from_data = this.$refs.SkyStepViewCreateProject.$refs.renderForm.value

      var reportSize = 0
      var list = []
      let bindReportTooMore = false
      if (from_data.envRelateSceneArr) {
        from_data.envRelateSceneList = from_data.envRelateSceneArr.map(item => {
          reportSize += item.envData.length
          if (reportSize > 5) {
            bindReportTooMore = true
          }
          item.envData.map(obj => list.push(obj.id))
          return {
            collectReportIdArr: item.envData.map(obj => obj.id),
            sceneId: item.scene
          }
        })
      }
      if (bindReportTooMore) {
        this.$store.dispatch('OpenNotification', { message: '一个场景最多只支持绑定5个报告', type: 'error' })
        return false
      }
      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '还有必填项未填写，请检查！', type: 'error' })
        return false
      }
      from_data.salesId = from_data.salesIdLabel.id
      from_data.presalesId = from_data.presalesIdLabel.id
      from_data.postsalesIdList = []
      from_data.postsalesIdLabelList.forEach(element => {
        from_data.postsalesIdList.push(element.id)
      })
      from_data.extensionIdList = []
      from_data.extensionIdLabelList.forEach(element => {
        from_data.extensionIdList.push(element.id)
      })

      if (this.projectId) {
        from_data.id = this.projectId
        await editProject(from_data)
          .then(res => {
            this.$emit('changeProjectId', {
              projectId: this.projectId,
              customer: from_data.customer,
              industryId: from_data.industryId
            })
          })
          .catch(e => {
            result = false
          })
      } else {
        await createProject(from_data)
          .then(res => {
            this.$emit('changeProjectId', {
              projectId: res.data.content,
              customer: from_data.customer,
              industryId: from_data.industryId
            })
          })
          .catch(e => {
            result = false
          })
      }
      return result
    },
    gotoPreStep() {
      return false
    }
  },
  created() {
    this.updateData()
  },
  data() {
    const ptFormViewCopy = extend(true, {}, ptFormView)
    ptFormViewCopy.toolbar = {
      hasToolbar: false
    }
    if (this.projectId) {
      ptFormViewCopy.params = {
        id: this.projectId
      }
      // for (let index = 0; index < ptFormViewCopy.view.content.length; index++) {
      //   const element = ptFormViewCopy.view.content[index]
      //   if (element.$id === 'envRelateSceneArr') {
      //     ptFormViewCopy.view.content.splice(index, 1)
      //   }
      // }
      ptFormViewCopy.needFetchFillInfo = true
      this.$emit('showBtns', {
        preStep: false,
        nextStep: true,
        saveStep: false,
        enableTabChange: true
      })
    } else {
      this.$emit('showBtns', {
        preStep: false,
        nextStep: true,
        saveStep: false,
        enableTabChange: true
      })
      // const exists = ptFormViewCopy.view.content.some(obj => obj.$id === 'envRelateSceneArr')
      // if (!exists) {
      //   ptFormViewCopy.view.content.splice(1, 0, {
      //     $id: 'envRelateSceneArr',
      //     $type: 'sky-env-relate-scene',
      //     label: 'pocMng.bindEnvAndSceneRelation',
      //     $el: { industryId: null },
      //     $enableWhen: {
      //       industryId: function(currentValue, data, meta) {
      //         // 如果有值设置
      //         if (currentValue != null) {
      //           meta.$el.industryId = currentValue
      //         }
      //         return true
      //       }
      //     },
      //     rules: [{ notEmpty: 'pipelineManage.branches' }]
      //   })
      // }
    }
    ptFormViewCopy.ref = 'SkyStepViewCreateProject'
    ptFormViewCopy.class = 'xxxxxxxxd'
    const metaView = ptFormViewCopy

    return {
      metaView: metaView
    }
  },
  render(h) {
    return createViewVNode(this.metaView, h)
  }
}
</script>
